var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex fd-column h-100 bg-white"},[_c('app-header',{attrs:{"header-options":_vm.headerOptions}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }